module.exports = __webpack_public_path__ + "img/illustration.6efc0e2f.png";